import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { useModalService } from 'hooks/useModalService';
import React, { ReactElement } from 'react';
import { ModalVariant } from 'types/Modal';

type Props = {
  imageUrl: string;
  title: string;
  description?: string;
  alt?: string;
  id?: string;
};

export const ImageCard = ({ imageUrl, title, description, alt, id }: Props): ReactElement => {
  const modalService = useModalService();

  const handleImageClick = (): void => {
    modalService.show(ModalVariant.IMAGE, {
      imgUrl: imageUrl,
      title,
      description,
    });
  };

  return (
    <Flex flexDir="column" gap="10px" id={id}>
      <Box
        borderRadius={8}
        overflow="hidden"
        flexGrow={1}
        width="100%"
        height={{ base: '110px', md: '180px' }}
        maxHeight={{ base: '110px', md: '180px' }}
        position="relative"
        onClick={handleImageClick}
        cursor="pointer"
      >
        <Image
          src={imageUrl}
          alt={alt || title}
          width="100%"
          height="100%"
          objectFit="cover"
          loading="lazy"
        />
      </Box>
      <Text
        textStyle={{ base: 'body.s.regular', md: 'body.m.regular' }}
        color="text.secondary"
        lineClamp={2}
      >
        {title}
      </Text>
    </Flex>
  );
};
